import { BASE_URL } from "configs/AppConfig"
import { AUTH_TOKEN } from "constants/AuthConstant"
import { io } from "socket.io-client"

export const socket = io(BASE_URL, {
  path: "/socket.io",
  transports: ["polling", "websocket"],
  autoConnect: false,
})

socket.on("connect", () => {
  console.log("🔌 CONNECTED", socket.id)
})

socket.on("connect_error", (err) => {
  console.error("❌ SOCKET ERROR:", err.message)
})
